export default __webpack_public_path__ + "static/media/mail.eb23b1e8.svg";